import { useUnreadCounts as useGenericUnreadCounts } from '../../../services/messagerie/useUnreadCounts';

export type { MessageChannel, UnreadCounts } from '../../../services/messagerie/useUnreadCounts';

// Compteurs de non-lus cote PRESTATAIRE MS. Rebranche sur le hook generique partage
// (module /subsequents, role prestataire) : ne differe de l'acheteur que par le role,
// desormais un simple argument au lieu d'une copie du hook.
export const useCommandeMsUnreadCounts = (operationId?: number | string) =>
  useGenericUnreadCounts('/subsequents', 'prestataire', operationId);
